(ns common.widgets.panel
  {:deprecated true}
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Paper$default" :as Paper]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [common.util :refer [spread-obj]]
            [uix.core :refer [$ defui]]))

(defui panel-header [{:keys [title sub-title actions]}]
  ($ Stack {:spacing 1
            :py 2.5}
     ($ Box {:sx #js {:display "flex"
                      :alignItems "center"
                      :justifyContent "space-between"}}
        ($ Typography {:variant "h2"
                       :data-testid :panel-header-title} title)
        ($ Box {:sx #js {:display "flex"
                         :gap 1}
                :data-testid :panel-header-actions}
           actions))
     (when sub-title
       ($ Typography {:variant "h3"} sub-title))))

(defui panel
  {:deprecated true}
  [{:keys [title sub-title actions footer table-content? children]
    :as props}]
  ($ Stack
     (dissoc props
             :title :sub-title :actions
             :footer :table-content?)
     (when (or title sub-title actions)
       ($ panel-header {:title title
                        :sub-title sub-title
                        :actions actions}))
     ($ Paper {:sx #js {:display "flex"
                        :flexDirection "column"
                        :flex 1
                        :py 3}}
        ($ Stack {:sx (spread-obj
                       #js {:flex 1
                            :px 3}
                       (when table-content?
                         #js {:px 0}))}
           children)
        (when (some? footer)
          ($ Box {:sx #js {:display "flex"
                           :justifyContent "end"
                           :padding 3
                           :pb 0}}
             footer)))))
